export default __webpack_public_path__ + "static/media/F9.a0a71d69.svg";